import { DEFAULT_INTERVAL } from './constants';
// This function takes in a range of values and calculates a suitable interval to
// divide that range into smaller segments for display purposes.
var getInterval = function (min, max) {
    var range = max - min;
    /* Important condition, Do not remove without proper testing!
    In the below algorithm, Math.log10(range) returns (-Infinity), when range = 0, causing bugs.
    This condition bypasses the above flaw */
    if (range === 0)
        return DEFAULT_INTERVAL;
    // This formula calculates an interval that is a power of 10,
    //  such as 1, 10, 100, etc., based on the magnitude of the range.
    var interval = Math.pow(10, Math.floor(Math.log10(range)));
    // The array [1, 2, 5] represents a common set
    // of "step" values used to create commonly-used and visually appealing intervals on a graph or chart.
    var steps = [1, 2, 5];
    for (var i = 0; i < steps.length; i++) {
        if (range / (interval * steps[i]) <= 8) {
            interval *= steps[i];
            break;
        }
    }
    return interval;
};
export var getAxisRanges = function (testData) {
    var xmin = testData[0].x, xmax = testData[0].x, ymin = testData[0].y, ymax = testData[0].y;
    // find minimum and maximum values for x and y
    for (var i = 0; i < testData.length; i++) {
        var _a = testData[i], x = _a.x, y = _a.y;
        if (x < xmin)
            xmin = x;
        if (x > xmax)
            xmax = x;
        if (y < ymin)
            ymin = y;
        if (y > ymax)
            ymax = y;
    }
    // calculate a suitable interval for a range of values between min and max.
    var xInterval = getInterval(xmin, xmax);
    var yInterval = getInterval(ymin, ymax);
    return {
        xMin: xmin - xInterval,
        xMax: xmax + xInterval,
        yMin: ymin - yInterval,
        yMax: ymax + yInterval,
        xInterval: xInterval,
        yInterval: yInterval
    };
};
// function to extract the style applicable to a given element when a function is exposed to user
export var getCallableStyles = function (allStyles, element, id) {
    var getElementStyle = allStyles[element];
    if (getElementStyle) {
        return getElementStyle(id);
    }
    return {};
};
